module.exports = __webpack_public_path__ + "img/19_96.bd5187b1.png";